var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isInDevEnvironment)?_c('section',{staticClass:"card-show-in-dev"},[_vm._t("default",function(){return [_vm._v(" Put your content here ")]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }